module.exports = __webpack_public_path__ + "assets/img/star_sentence_select4.4836f0c7.png";